import { EntryPanel } from './EntryPanel'
import { ProcessingPanel } from './ProcessingPanel'
import useAppSelector from '../../../../hooks/useAppSelector'
import {
  PanelState,
  getPanelStateSelector,
  getSelectedEntrySelector,
} from '../../checkinSlice'

export const CheckinModalContent = () => {
  const panelState = useAppSelector(getPanelStateSelector)

  const entry = useAppSelector(getSelectedEntrySelector)
  if (!entry) {
    return null
  }

  switch (panelState) {
    case PanelState.EDIT:
      return <EntryPanel />
    case PanelState.PROCESSING:
      return <ProcessingPanel />
    case PanelState.HIDDEN:
    case PanelState.ERROR: // TODO error UI
      return null
  }
}
